import { X } from "lucide-react";

import { IgButton, IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { Box, Dialog } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useDialog } from "@src/hooks/dialog";
import firstExperienceLaunchedSvg from "@src/images/get-started/first_experience_launched.svg";

const TargetGraphic = () => (
  <Box
    component="img"
    src={firstExperienceLaunchedSvg}
    alt="first experience launched"
    sx={{ width: "100%", height: 180, objectFit: "contain" }}
  />
);

export const FirstExperienceLaunchedDialog = () => {
  const dialog = useDialog("firstExperienceLaunched");

  const handleClose = () => {
    dialog.close();
  };

  return (
    <Dialog
      open={dialog.isOpen}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            width: "100%",
            maxWidth: { sm: "100%", md: 650 },
            p: 8,
          },
        },
      }}
    >
      <Stack spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <IgTypography variant="h2" fontWeight={600}>
            You did it, first experience launched!
          </IgTypography>
          <IgIconButton onClick={handleClose}>
            <X size={20} />
          </IgIconButton>
        </Stack>

        <IgTypography variant="h3" sx={{ color: "text.secondary" }}>
          Your test is now collecting data. Keep building while you wait for
          results.
        </IgTypography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "primary.50",
            borderRadius: "8px",
            py: 3,
          }}
        >
          <TargetGraphic />
        </Box>

        <Stack direction="row" justifyContent="flex-end">
          <IgButton variant="contained" onClick={handleClose}>
            Continue
          </IgButton>
        </Stack>
      </Stack>
    </Dialog>
  );
};
